// Tenhle soubor generuje scripts/build-photos.mjs – needituj ho ručně.
// Fotky na webu se mění v SELECTION v tom skriptu.
//
// U každé fotky existují čtyři soubory:
//   <cesta>.webp        barevná, velká
//   <cesta>-bw.webp     černobílá, velká
//   <cesta>-t.webp      barevná, náhled
//   <cesta>-bw-t.webp   černobílá, náhled

export interface HeroSlide {
  src: string;
  mobile: string;
  position: string;
}

export interface Gallery {
  slug: string;
  title: string;
  /** Cesty bez přípony – varianty se skládají v komponentě ThemePhoto. */
  photos: string[];
}

/** Úvodní fotky jsou vždy černobílé, v obou režimech. */
export const HERO_SLIDES: HeroSlide[] = [
  {
    "src": "/photos/hero/01.webp",
    "mobile": "/photos/hero/01-m.webp",
    "position": "center 45%"
  },
  {
    "src": "/photos/hero/02.webp",
    "mobile": "/photos/hero/02-m.webp",
    "position": "center 55%"
  },
  {
    "src": "/photos/hero/03.webp",
    "mobile": "/photos/hero/03-m.webp",
    "position": "center 55%"
  },
  {
    "src": "/photos/hero/04.webp",
    "mobile": "/photos/hero/04-m.webp",
    "position": "center 40%"
  },
  {
    "src": "/photos/hero/05.webp",
    "mobile": "/photos/hero/05-m.webp",
    "position": "center 50%"
  }
];

export const GALLERIES: Gallery[] = [
  {
    "slug": "portretni",
    "title": "Portrétní",
    "photos": [
      "/photos/galerie/portretni/01",
      "/photos/galerie/portretni/02",
      "/photos/galerie/portretni/03",
      "/photos/galerie/portretni/04",
      "/photos/galerie/portretni/05",
      "/photos/galerie/portretni/06",
      "/photos/galerie/portretni/07",
      "/photos/galerie/portretni/08",
      "/photos/galerie/portretni/09",
      "/photos/galerie/portretni/10",
      "/photos/galerie/portretni/11",
      "/photos/galerie/portretni/12"
    ]
  },
  {
    "slug": "parove",
    "title": "Párové",
    "photos": [
      "/photos/galerie/parove/01",
      "/photos/galerie/parove/02",
      "/photos/galerie/parove/03",
      "/photos/galerie/parove/04",
      "/photos/galerie/parove/05",
      "/photos/galerie/parove/06",
      "/photos/galerie/parove/07",
      "/photos/galerie/parove/08",
      "/photos/galerie/parove/09",
      "/photos/galerie/parove/10",
      "/photos/galerie/parove/11",
      "/photos/galerie/parove/12"
    ]
  },
  {
    "slug": "rodinne",
    "title": "Rodinné",
    "photos": [
      "/photos/galerie/rodinne/01",
      "/photos/galerie/rodinne/02",
      "/photos/galerie/rodinne/03",
      "/photos/galerie/rodinne/04",
      "/photos/galerie/rodinne/05",
      "/photos/galerie/rodinne/06",
      "/photos/galerie/rodinne/07",
      "/photos/galerie/rodinne/08",
      "/photos/galerie/rodinne/09",
      "/photos/galerie/rodinne/10",
      "/photos/galerie/rodinne/11",
      "/photos/galerie/rodinne/12",
      "/photos/galerie/rodinne/13",
      "/photos/galerie/rodinne/14"
    ]
  },
  {
    "slug": "tehotenske",
    "title": "Těhotenské",
    "photos": [
      "/photos/galerie/tehotenske/01",
      "/photos/galerie/tehotenske/02",
      "/photos/galerie/tehotenske/03",
      "/photos/galerie/tehotenske/04",
      "/photos/galerie/tehotenske/05",
      "/photos/galerie/tehotenske/06",
      "/photos/galerie/tehotenske/07",
      "/photos/galerie/tehotenske/08",
      "/photos/galerie/tehotenske/09",
      "/photos/galerie/tehotenske/10",
      "/photos/galerie/tehotenske/11",
      "/photos/galerie/tehotenske/12"
    ]
  },
  {
    "slug": "svatebni",
    "title": "Svatební",
    "photos": [
      "/photos/galerie/svatebni/01",
      "/photos/galerie/svatebni/02"
    ]
  }
];
